import React, { useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Collapse,
  Grid,
  IconButton,
  Link,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { CustomInputField } from "../CommonComponents/CustomCompontes";
import EditIcon from "@mui/icons-material/Edit";
import DoneIcon from "@mui/icons-material/Done";

import { companyWiseEmp } from "../../actions/Companywiseclient";

// const UndertakingTableFormRow = ({rowData, index})=> {
//   const [openDepartmentList, setOpenDepartmentList] = React.useState(false)

//   return (
//     <React.Fragment key={`undertaking-form-${index}`}>
//     <TableRow>
//       <TableCell>{index + 1}</TableCell>
//       <TableCell>{rowData?.name|| "-"}</TableCell>
//       <TableCell>
//       <Typography
//       component={Link}
//       href={rowData?.undertakingFormUrl || ""}
//       target="_blank"
//     >
//       {rowData?.undertakingFormUrl || ""}
//     </Typography>
//       </TableCell>
//       <TableCell>
//       <IconButton
//                     sx={{
//                       transition: "transform 0.3s ease",
//                     }}
//                     onClick={(e) => {
//                       e.stopPropagation();

//                       setOpenDepartmentList(prev=> !prev);
//                     }}
//                   >
//                     <KeyboardArrowDownIcon
//                       sx={{
//                         fontWeight: 600,
//                         transform: openDepartmentList
//                           ? "rotate(180deg)"
//                           : "rotate(0deg)",
//                         transition: "transform 0.3s ease",
//                       }}
//                     />
//                   </IconButton>
//       </TableCell>
//     </TableRow>
//     <TableRow>
//     <td colSpan={12}>
//         <Collapse
//         in={openDepartmentList}
//         timeout="auto"
//         unmountOnExit
//         >
//                         <TableContainer>
//                 <Table
//                   stickyHeader
//                   sx={{
//                     borderCollapse: "initial",
//                   }}
//                 >
//                           <TableHead
//                           sx={{margin:"0px !importnant", padding:"0 !important"}}
//                 >
//                   <TableCell className="tabalecellStyle" sx={{ color: "#fff", backgroundColor: "#32577e", paddingY:"2.3px" }}>Sl No.</TableCell>
//                   <TableCell className="tabalecellStyle" sx={{ color: "#fff", backgroundColor: "#32577e", paddingY:"2.3px" }}>
//                     Department Name
//                   </TableCell>
//                   <TableCell className="tabalecellStyle" sx={{ color: "#fff", backgroundColor: "#32577e", paddingY:"2.3px" }}>
//                     Is Undertaking Required
//                   </TableCell>
//                 </TableHead>

//                 </Table>
//         </TableContainer>
//         </Collapse>
//       </td>
//     </TableRow>
// </React.Fragment>
//   )
// }

const FormRow = ({
  isSelectedRow = false,
  index,
  rowData,
  handleSaveUndertakingForm = () => {},
  handleSetValuesForCompleteFormUpdate = () => {},
}) => {
  const toBeUpdatedFileRef = React.useRef(null);
  const [toBeUpdatedFile, setToBeUpdatedFile] = React.useState("");
  const [updateKey, setUpdateKey] = React.useState("");
  const [updatedFormName, setUpdatedFormName] = React.useState("");
  const [isUpdateFormApiFetching, setIsUpdateFormApiFetching] =
    React.useState(false);

  const [isFormEnable, setIsFormEnable] = React.useState(false);

  const handleSaveAndClose = (isUpdatedFormFile) => {
    setIsUpdateFormApiFetching(true);
    handleSaveUndertakingForm({
      isUpdate: true,
      objForPayload: {
        updatedFormName:
          isUpdatedFormFile === "formName" ? updatedFormName : rowData?.name,
        formId: rowData?.id,
        isFormActive:
          isUpdatedFormFile === "formEnable"
            ? !isFormEnable
            : rowData?.isActive,
        updatedFormFile:
          isUpdatedFormFile === "formFile"
            ? toBeUpdatedFileRef?.current?.files[0]
            : null,
      },
    })
      .then((res) => {
        if (res?.success) {
          setUpdateKey("");
          setUpdatedFormName("");
          setToBeUpdatedFile("");
          toBeUpdatedFileRef.current.value = "";
        }
        setIsUpdateFormApiFetching(false);
      })
      .catch((err) => {
        console.log("err:", err);
        setIsUpdateFormApiFetching(false);
      });
  };

  React.useEffect(() => {
    setIsFormEnable(rowData?.isActive || false);
  }, [rowData?.isActive]);

  return (
    <TableRow key={`undertaking-form-${index}`}>
      <TableCell>{index + 1}</TableCell>
      <TableCell>
        {Boolean(updateKey === "formName") ? (
          <TextField
            id="outlined-required"
            variant="standard"
            name="actualName"
            value={updatedFormName}
            onChange={(e) => setUpdatedFormName(e?.target?.value)}
            sx={{ padding: 0, margin: "0px !important" }}
          />
        ) : (
          rowData?.name || "-"
        )}

        {Boolean(updateKey === "formName") ? (
          <>
            <Tooltip title="Edit Form Name">
              <IconButton
                disabled={isUpdateFormApiFetching}
                style={{ color: isUpdateFormApiFetching ? "grey" : "green" }}
                onClick={() => handleSaveAndClose("formName")}
              >
                <DoneIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Close">
              <IconButton
                disabled={isUpdateFormApiFetching}
                style={{ color: isUpdateFormApiFetching ? "grey" : "red" }}
                onClick={() => setUpdateKey("")}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </>
        ) : (
          <></>
          // <Tooltip title="Edit Form Name">
          //   <IconButton
          //     style={{ color: "green" }}
          //     onClick={() => {
          //       setUpdateKey("formName");
          //       setUpdatedFormName(rowData?.name || "");
          //     }}
          //   >
          //     <EditIcon />
          //   </IconButton>
          // </Tooltip>
        )}
      </TableCell>

      <TableCell>
        {Boolean(updateKey === "formFile") ? (
          <>
            <CustomInputField
              sx={{
                // width: "100%",
                margin: "0px !important",
              }}
              // required
              id="outlined-basic"
              inputRef={toBeUpdatedFileRef}
              label="Upload Undertaking Form"
              name="uploadUndertakingForm"
              variant="outlined"
              size="small"
              type="file"
              InputLabelProps={{ shrink: true }}
              inputProps={
                {
                  //   accept: "image/png, image/jpeg",
                }
              }
              onChange={(e) => setToBeUpdatedFile(e.target.value)}
            />

            {Boolean(toBeUpdatedFile) && (
              <Tooltip title="Save">
                <IconButton
                  disabled={isUpdateFormApiFetching}
                  style={{ color: isUpdateFormApiFetching ? "grey" : "green" }}
                  onClick={() => handleSaveAndClose("formFile")}
                >
                  <DoneIcon />
                </IconButton>
              </Tooltip>
            )}

            <Tooltip title="Cancel">
              <IconButton
                disabled={isUpdateFormApiFetching}
                style={{ color: isUpdateFormApiFetching ? "grey" : "red" }}
                onClick={() => {
                  setUpdateKey("");
                  setToBeUpdatedFile("");
                  toBeUpdatedFileRef.current.value = "";
                }}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </>
        ) : (
          <>
            <Typography
              component={Link}
              href={rowData?.undertakingFormUrl || ""}
              target="_blank"
              sx={{ ml: "6px" }}
            >
              {rowData?.undertakingFormUrl || ""}
            </Typography>

            {/* <Tooltip title="Update File">
              <IconButton
                style={{ color: "green" }}
                onClick={() => {
                  setUpdateKey("formFile");
                }}
              >
                <EditIcon />
              </IconButton>
            </Tooltip> */}
          </>
        )}
      </TableCell>

      <TableCell>
        {/* <Tooltip
          title={rowData?.isActive ? "Enabled" : "Disabled"}
          arrow
          PopperProps={{
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, -4],
                },
              },
            ],
          }}
        >
          <Switch
            disabled={isUpdateFormApiFetching}
            checked={isFormEnable}
            onClick={() => handleSaveAndClose("formEnable")}
            color="secondary"
          />
        </Tooltip> */}
        {isSelectedRow ? (
          <Tooltip title="Cancel">
            <IconButton
              disabled={isUpdateFormApiFetching}
              style={{ color: isUpdateFormApiFetching ? "grey" : "red" }}
              onClick={() => {
                setUpdateKey("");
                handleSetValuesForCompleteFormUpdate();
                // setToBeUpdatedFile("");
                // toBeUpdatedFileRef.current.value = "";
              }}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Edit Form">
            <IconButton
              style={{ color: "green" }}
              onClick={() => {
                setUpdateKey("completeUpdate");
                handleSetValuesForCompleteFormUpdate({ formObj: rowData });
                // setUpdatedFormName(rowData?.name || "");
              }}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        )}
      </TableCell>
    </TableRow>
  );
};

const FormRowForDepartment = ({
  form,
  index,
  rowData,
  handleIsUndertakingRequiredStatusChange = () => {},
  handleSaveUndertakingForm = () => {},
}) => {
  const [isEdit, setIsEdit] = React.useState(false);
  const [updatedFormName, setUpdatedFormName] = React.useState("");
  const [isUpdateFormApiFetching, setIsUpdateFormApiFetching] =
    React.useState(false);

  const handleSaveAndClose = () => {
    setIsUpdateFormApiFetching(true);
    handleSaveUndertakingForm({
      isUpdate: true,
      objForPayload: {
        updatedFormName,
        formId: form?.id,
        isFormActive: form?.isActive,
      },
    })
      .then((res) => {
        if (res?.success) {
          setIsEdit(false);
          setUpdatedFormName("");
        }
        setIsUpdateFormApiFetching(false);
      })
      .catch((err) => {
        console.log("err:", err);
        setIsUpdateFormApiFetching(false);
      });
  };

  return (
    <TableRow key={`isRequired-form-${index}`}>
      <TableCell>{index + 1}</TableCell>
      <TableCell></TableCell>
      <TableCell>
        {Boolean(isEdit) ? (
          <TextField
            id="outlined-required"
            variant="standard"
            name="actualName"
            value={updatedFormName}
            onChange={(e) => setUpdatedFormName(e?.target?.value)}
            sx={{ padding: 0, margin: "0px !important" }}
          />
        ) : (
          form?.name || "-"
        )}

        {Boolean(isEdit) ? (
          <Tooltip title="Edit Form Name">
            <IconButton
              disabled={isUpdateFormApiFetching}
              style={{ color: isUpdateFormApiFetching ? "grey" : "green" }}
              onClick={() => handleSaveAndClose()}
            >
              <DoneIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Typography
            component={Link}
            href={form?.undertakingFormUrl || ""}
            target="_blank"
            sx={{ ml: "6px" }}
          >
            {form?.undertakingFormUrl || ""}
          </Typography>
        )}
      </TableCell>

      <TableCell>
        <Checkbox
          size="small"
          checked={
            Array.isArray(rowData?.undertakingFormList) &&
            rowData?.undertakingFormList?.some((item) => item?.id === form?.id)
          }
          onChange={(e) =>
            handleIsUndertakingRequiredStatusChange(e, rowData, form)
          }
        />
      </TableCell>

      {/* <TableCell>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 1,
          }}
        >
          {isEdit ? (
            <Tooltip title="Close">
              <IconButton
                style={{ color: "red" }}
                onClick={() => setIsEdit(false)}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Edit Form Name">
              <IconButton
                style={{ color: "green" }}
                onClick={() => {
                  setIsEdit(true);
                  setUpdatedFormName(form?.name || "");
                }}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </TableCell> */}
    </TableRow>
  );
};

const DepartmentUndertakingTableFormRow = ({
  rowData,
  index,
  undertakingFormList = [],
  handleIsUndertakingRequiredStatusChange = () => {},
  handleDepartmentStatusChange = () => {},
  handleSaveUndertakingForm,
}) => {
  const [openUndertakingFormList, setOpenUndertakingFormList] =
    React.useState(false);

  React.useEffect(() => {
    if (!rowData?.isUndertakingFormRequired) {
      setOpenUndertakingFormList(false);
    }
  }, [rowData?.isUndertakingFormRequired]);

  return (
    <React.Fragment>
      <TableRow>
        <TableCell>{index + 1}</TableCell>
        <TableCell>
          {rowData?.departmentName || "-"}
          {/* {(rowData?.isUndertakingFormRequired === true || true) && (
            <IconButton
              sx={{
                transition: "transform 0.3s ease",
              }}
              onClick={(e) => {
                e.stopPropagation();

                setOpenUndertakingFormList((prev) => !prev);
              }}
            >
              <KeyboardArrowDownIcon
                sx={{
                  fontWeight: 600,
                  transform: openUndertakingFormList
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              />
            </IconButton>
          )} */}
        </TableCell>
        {/* <TableCell></TableCell> */}

        {/* <TableCell>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 1,
            }}
          >
            <Tooltip
              title={
                rowData?.isUndertakingFormRequired ? "Enabled" : "Disabled"
              }
              arrow
              PopperProps={{
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, -4],
                    },
                  },
                ],
              }}
            >
              <Switch
                checked={rowData?.isUndertakingFormRequired}
                onChange={(e) => handleDepartmentStatusChange(e, rowData)}
                color="secondary"
              />
            </Tooltip>
          </Box>
        </TableCell> */}

        <TableCell>
          <IconButton
            sx={{
              transition: "transform 0.3s ease",
            }}
            onClick={(e) => {
              e.stopPropagation();

              setOpenUndertakingFormList((prev) => !prev);
            }}
          >
            <KeyboardArrowDownIcon
              sx={{
                fontWeight: 600,
                transform: openUndertakingFormList
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
                transition: "transform 0.3s ease",
              }}
            />
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <td colSpan={12}>
          <Collapse in={openUndertakingFormList} timeout="auto" unmountOnExit>
            <TableContainer>
              <Table
                stickyHeader
                sx={{
                  borderCollapse: "initial",
                }}
              >
                <TableHead
                  sx={{ margin: "0px !importnant", padding: "0 !important" }}
                >
                  <TableCell
                    className="tabalecellStyle"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#4678ac",
                      paddingY: "2.3px",
                    }}
                  >
                    Sl No.
                  </TableCell>
                  <TableCell
                    className="tabalecellStyle"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#4678ac",
                      paddingY: "2.3px",
                      px: { md: 3.5 },
                    }}
                  ></TableCell>
                  <TableCell
                    className="tabalecellStyle"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#4678ac",
                      paddingY: "2.3px",
                    }}
                  >
                    Form Name
                  </TableCell>
                  <TableCell
                    className="tabalecellStyle"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#4678ac",
                      paddingY: "2.3px",
                    }}
                  >
                    Is Undertaking Required
                  </TableCell>
                  {/* <TableCell
                    className="tabalecellStyle"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#4678ac",
                      paddingY: "2.3px",
                    }}
                  >
                    Action
                  </TableCell> */}
                </TableHead>
                <TableBody>
                  {undertakingFormList?.map((form, index) => {
                    return (
                      <FormRowForDepartment
                        form={form}
                        index={index}
                        rowData={rowData}
                        handleIsUndertakingRequiredStatusChange={
                          handleIsUndertakingRequiredStatusChange
                        }
                        handleSaveUndertakingForm={handleSaveUndertakingForm}
                      />
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Collapse>
        </td>
      </TableRow>
    </React.Fragment>
  );
};

const UnderTakingFormUpload = ({ companyId }) => {
  const fileRef = React.useRef(null);
  const [file, setFile] = React.useState("");
  const [fileApiUrl, setFileApiUrl] = React.useState("");
  // const [savedUndertakingObj, setSavedUndertakingObj] = React.useState(null);
  const [departmentList, setDepartmentList] = React.useState([]);
  const [undertakingFileName, setUndertakingFileName] = React.useState("");
  const [allUndertakingFormList, setAllUndertakingFormList] = React.useState(
    []
  );
  const [isActiveUndertakingFormList, setIsActiveUndertakingFormList] =
    React.useState([]);

  const [toBeUpdatedFormObj, setToBeUpdatedFormObj] = React.useState(null);

  // console.log("somya ?: ", typeof file, toBeUpdatedFormObj);

  const handleSetValuesForCompleteFormUpdate = ({ formObj = null } = {}) => {
    setUndertakingFileName(formObj?.name || "");
    setToBeUpdatedFormObj(formObj);
  };

  React.useEffect(() => {
    if (fileRef?.current) {
      fileRef.current.value = "";
    }
    setFile("");
    if (toBeUpdatedFormObj?.undertakingFormUrl) {
      setFileApiUrl(toBeUpdatedFormObj?.undertakingFormUrl);
    }

    if (!toBeUpdatedFormObj?.undertakingFormUrl) {
      setFileApiUrl("");
    }
  }, [toBeUpdatedFormObj]);

  // console.log("allUndertakingFormList : ", allUndertakingFormList)

  const handleSaveUndertakingForm = async ({
    isUpdate = false,
    objForPayload = {
      updatedFormName: "",
      formId: null,
      isFormActive: null,
      updatedFormFile: null,
    },
  } = {}) => {
    const payload = new FormData();
    if (isUpdate) {
      if (!Boolean(objForPayload?.updatedFormName?.trim())) {
        alert("Please give a valid name !!!");
        return;
      }
      payload.append("hrmsCompanyId", companyId);
      payload.append("name", objForPayload?.updatedFormName?.trim());
      payload.append("id", objForPayload?.formId);
      payload.append("isActive", objForPayload?.isFormActive);

      if (objForPayload?.updatedFormFile) {
        payload.append("file", objForPayload?.updatedFormFile);
      }
    } else if (!isUpdate) {
      if (!Boolean(undertakingFileName?.trim())) {
        alert("Please give a valid name !");
        return;
      }

      payload.append("hrmsCompanyId", companyId);
      payload.append("file", fileRef.current.files[0]);
      payload.append("name", undertakingFileName?.trim());
    }
    // if (savedUndertakingObj) {
    //   payload.append("id", savedUndertakingObj.id);
    // }

    const response = await companyWiseEmp.saveUndertakingForm(payload);
    if (response.responseCode === 200) {
      setFile("");
      // fetchUndertakingByCompanyId();
      fetchIsActiveUndertakingFormsByCompanyId();
      fetchAllUndertakingFormsByCompanyId();
      if (fileRef?.current) {
        fileRef.current.value = "";
      }
      setUndertakingFileName("");
      setToBeUpdatedFormObj(null);
      // return alert(response.responseDescription);
      alert(response.responseDescription);
      if (isUpdate) return { success: true, response };
    } else {
      // return alert(response?.responseDescription || response);
      alert(response?.responseDescription || response);
      if (isUpdate) return { success: false, response };
    }
  };

  // const fetchUndertakingByCompanyId = async () => {
  //   const response = await companyWiseEmp.getUndertakingByCompanyId(companyId);
  //   if (response?.responseCode === 200 && response?.data?.undertakingFormUrl) {
  //     setFileApiUrl(response?.data?.undertakingFormUrl);
  //     setSavedUndertakingObj(response.data);
  //   } else {
  //     setFileApiUrl("");
  //     setSavedUndertakingObj(null);
  //   }
  // };

  const fetchAllUndertakingFormsByCompanyId = async () => {
    const response = await companyWiseEmp.getAllUndertakingFormsByCompanyId(
      companyId
    );
    if (response?.responseCode === 200) {
      setAllUndertakingFormList(response?.data);
    } else {
      setAllUndertakingFormList([]);
    }
  };

  const fetchIsActiveUndertakingFormsByCompanyId = async () => {
    const response = await companyWiseEmp.getAllUndertakingFormsByCompanyId(
      companyId,
      true
    );
    if (response?.responseCode === 200) {
      setIsActiveUndertakingFormList(response?.data);
    } else {
      setIsActiveUndertakingFormList([]);
    }
  };

  const fetchDepartmentConfigurationByCompanyId = async () => {
    const response = await companyWiseEmp.getDepartmentConfigurationByCompanyId(
      {
        hrmsCompanyId: companyId,
        hrmsToken: JSON.parse(localStorage.getItem("data")).hrmsToken,
      }
    );
    if (response !== null && response.responseCode === 200) {
      setDepartmentList(response.data);
    } else {
      setDepartmentList([]);
    }
  };

  const handleRemoveUndertakingUrl = () => {
    setFileApiUrl("");
  };

  // const handleStatusChange = async (e, department) => {
  //   const response = await companyWiseEmp.saveDepartmentConfiguration({
  //     hrmsCompanyId: companyId,
  //     id: department.id,
  //     departmentId: department.departmentId,
  //     departmentName: department.departmentName,
  //     isUndertakingFormRequired: e.target.checked,
  //   });
  //   if (response?.responseCode === 200) {
  //     fetchDepartmentConfigurationByCompanyId();
  //     alert(response.responseDescription);
  //   } else {
  //     alert(response?.responseDescription || response);
  //   }
  // };

  const handleIsUndertakingRequiredStatusChange = async (
    e,
    department,
    form
  ) => {
    const finalUndertakingFormArr = (department?.undertakingFormList || [])
      .map((f) => f?.id)
      .filter(Boolean)
      .filter((id) => e?.target?.checked || id !== form?.id)
      .concat(
        e?.target?.checked &&
          !department?.undertakingFormList?.some((f) => f?.id === form?.id)
          ? [form?.id]
          : []
      );

    const response = await companyWiseEmp.saveDepartmentConfiguration({
      hrmsCompanyId: companyId,
      id: department.id,
      departmentId: department.departmentId,
      departmentName: department.departmentName,
      // isUndertakingFormRequired: Boolean(finalUndertakingFormArr?.length < 1)
      //   ? false
      //   : department?.isUndertakingFormRequired,
      isUndertakingFormRequired: true,
      // undertakingFormListIds: Boolean(finalUndertakingFormArr?.length < 1)
      //   ? (department?.undertakingFormList || [])
      //       .map((f) => f?.id)
      //       .filter(Boolean)
      //   : finalUndertakingFormArr,

      undertakingFormListIds: finalUndertakingFormArr,
    });
    if (response?.responseCode === 200) {
      fetchDepartmentConfigurationByCompanyId();
      alert(response.responseDescription);
    } else {
      alert(response?.responseDescription || response);
    }
  };

  const handleDepartmentStatusChange = async (e, department) => {
    const finalUndertakingFormArr = (department?.undertakingFormList || [])
      .map((f) => f?.id)
      .filter(Boolean);

    const response = await companyWiseEmp.saveDepartmentConfiguration({
      hrmsCompanyId: companyId,
      id: department.id,
      departmentId: department.departmentId,
      departmentName: department.departmentName,
      isUndertakingFormRequired: e?.target?.checked,
      undertakingFormListIds: finalUndertakingFormArr,
    });
    if (response?.responseCode === 200) {
      fetchDepartmentConfigurationByCompanyId();
      alert(response.responseDescription);
    } else {
      alert(response?.responseDescription || response);
    }
  };

  React.useEffect(() => {
    if (companyId) {
      // fetchUndertakingByCompanyId();
      fetchDepartmentConfigurationByCompanyId();
      fetchAllUndertakingFormsByCompanyId();
      fetchIsActiveUndertakingFormsByCompanyId();
    }
  }, [companyId]);

  return (
    <Accordion className="main_accoardian" defaultExpanded={true}>
      <AccordionSummary
        className="accordianHeader"
        expandIcon={
          <AddCircleIcon fontSize="large" style={{ color: "white" }} />
        }
        aria-controls="panel1a-content"
        style={{
          background: "rgb(10 166 141)",
          borderRadius: "10px 10px 0px 0px",
          overflow: "hidden",
        }}
      >
        <Grid>
          <Grid>
            <h3
              style={{
                color: "#fff",
                marginLeft: "10px",
                padding: "10px 2px",
              }}
            >
              Undertaking form upload & Department Configuration:-
            </h3>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ my: 1 }}>
          <Grid container direction="row" spacing={3} alignItems="center">
            <Grid item xs={12}>
              {Boolean(fileApiUrl?.trim()) && (
                <Grid
                  container
                  direction="row"
                  //justifyContent="center"
                  spacing={3}
                  alignItems="center"
                >
                  <Grid item xs={12}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography
                        component={Link}
                        href={fileApiUrl}
                        target="_blank"
                      >
                        {fileApiUrl}
                      </Typography>
                      <IconButton onClick={handleRemoveUndertakingUrl}>
                        <CloseIcon color="error" />
                      </IconButton>
                    </Box>
                  </Grid>
                </Grid>
              )}

              <Grid
                container
                direction="row"
                //justifyContent="center"
                spacing={3}
                alignItems="center"
              >
                {Boolean(!toBeUpdatedFormObj) && (
                  <Grid item md={3.55} lg={2.75} xl={2.25}>
                    <CustomInputField
                      sx={{
                        width: "100%",
                        margin: "0px !important",
                      }}
                      // required
                      id="outlined-basic"
                      inputRef={fileRef}
                      label="Upload Undertaking Form"
                      name="uploadUndertakingForm"
                      variant="outlined"
                      size="small"
                      type="file"
                      InputLabelProps={{ shrink: true }}
                      inputProps={
                        {
                          //   accept: "image/png, image/jpeg",
                        }
                      }
                      onChange={(e) => setFile(e.target.value)}
                    />
                  </Grid>
                )}

                {Boolean(
                  Boolean(toBeUpdatedFormObj) && !Boolean(fileApiUrl?.trim())
                ) && (
                  <Grid item md={3.55} lg={2.75} xl={2.25}>
                    <CustomInputField
                      sx={{
                        width: "100%",
                        margin: "0px !important",
                      }}
                      // required
                      id="outlined-basic"
                      inputRef={fileRef}
                      label="Upload Undertaking Form"
                      name="uploadUndertakingForm"
                      variant="outlined"
                      size="small"
                      type="file"
                      InputLabelProps={{ shrink: true }}
                      inputProps={
                        {
                          //   accept: "image/png, image/jpeg",
                        }
                      }
                      onChange={(e) => setFile(e.target.value)}
                    />
                  </Grid>
                )}
                <Grid item md={3.55} lg={2.75} xl={2.25}>
                  <CustomInputField
                    sx={{ width: "100%", margin: "0px !important" }}
                    required
                    value={undertakingFileName}
                    label="Form Name"
                    name="undertakingFormName"
                    size="small"
                    onChange={(e) => setUndertakingFileName(e?.target?.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item>
                  {Boolean(!toBeUpdatedFormObj) ? (
                    <>
                      {Boolean(file) && (
                        <div
                          className="field_box"
                          style={{
                            // backgroundColor: "orange",
                            paddingBottom: "12px",
                          }}
                          onClick={handleSaveUndertakingForm}
                        >
                          <div
                            className="field_box_btn1"
                            style={{
                              cursor: "pointer",
                              paddingLeft: "25px",
                              paddingRight: "25px",
                              paddingTop: "8px",
                              paddingBottom: "8px",
                              marginTop: 12,
                            }}
                            //   onClick={handleUploadUndertakingForm}
                          >
                            Save
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      className="field_box"
                      style={{
                        // backgroundColor: "orange",
                        paddingBottom: "12px",
                      }}
                      onClick={() => {
                        handleSaveUndertakingForm({
                          isUpdate: true,
                          objForPayload: {
                            updatedFormName: undertakingFileName?.trim(),
                            formId: toBeUpdatedFormObj?.id,
                            isFormActive: toBeUpdatedFormObj?.isActive,
                            updatedFormFile: fileRef?.current?.files[0],
                          },
                        });
                      }}
                    >
                      <div
                        className="field_box_btn1"
                        style={{
                          cursor: "pointer",
                          paddingLeft: "25px",
                          paddingRight: "25px",
                          paddingTop: "8px",
                          paddingBottom: "8px",
                          marginTop: 12,
                        }}
                        //   onClick={handleUploadUndertakingForm}
                      >
                        Update
                      </div>
                    </div>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        {/* {Boolean(allUndertakingFormList?.length>0) && (
          <Box>
            <TableContainer component={Paper}>
            <Table size="small">
            <TableHead
                  style={{ color: "#fff", backgroundColor: "#32577e" }}
                >
                  <TableCell className="tabalecellStyle">Sl No.</TableCell>
                  <TableCell className="tabalecellStyle">
                    Form Name
                  </TableCell>
                  <TableCell className="tabalecellStyle">
                    
                  </TableCell>
                  <TableCell className="tabalecellStyle">
                    Action
                    </TableCell>
                </TableHead>

                <TableBody>
                  {allUndertakingFormList.map((form, index) => {
                    return (
                    <UndertakingTableFormRow key={`undertaking-form-${index}`} rowData={form}index={index} />
                    );
                  })}
                </TableBody>
            </Table>
              </TableContainer>     
            </Box>
        )} */}

        {Boolean(allUndertakingFormList?.length > 0) && (
          <Box>
            <TableContainer
              component={Paper}
              sx={{ maxHeight: "350px", overflowY: "auto", mb: 3 }}
            >
              <Table
                size="small"
                stickyHeader
                sx={{
                  borderCollapse: "initial",
                }}
              >
                <TableHead
                // sx={{ margin: "0px !importnant", padding: "0 !important" }}
                >
                  <TableCell
                    className="tabalecellStyle"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#32577E",
                    }}
                  >
                    Sl No.
                  </TableCell>
                  <TableCell
                    className="tabalecellStyle"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#32577E",
                    }}
                  >
                    Form Name
                  </TableCell>
                  <TableCell
                    className="tabalecellStyle"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#32577E",
                    }}
                  >
                    File
                  </TableCell>

                  <TableCell
                    className="tabalecellStyle"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#32577E",
                    }}
                  >
                    Action
                  </TableCell>
                </TableHead>

                <TableBody>
                  {allUndertakingFormList.map((form, index) => {
                    return (
                      <FormRow
                        isSelectedRow={Boolean(
                          form?.id === toBeUpdatedFormObj?.id ? true : false
                        )}
                        key={`department-undertaking-form-${index}`}
                        rowData={form}
                        index={index}
                        undertakingFormList={allUndertakingFormList || []}
                        handleIsUndertakingRequiredStatusChange={
                          handleIsUndertakingRequiredStatusChange
                        }
                        handleDepartmentStatusChange={
                          handleDepartmentStatusChange
                        }
                        handleSaveUndertakingForm={handleSaveUndertakingForm}
                        handleSetValuesForCompleteFormUpdate={
                          handleSetValuesForCompleteFormUpdate
                        }
                      />
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}

        {Boolean(departmentList?.length > 0) && (
          <Box>
            <TableContainer
              component={Paper}
              sx={{ maxHeight: "550px", overflowY: "auto" }}
            >
              <Table
                size="small"
                stickyHeader
                sx={{
                  borderCollapse: "initial",
                }}
              >
                <TableHead
                // style={{ color: "#fff", backgroundColor: "#32577e" }}
                >
                  <TableCell
                    className="tabalecellStyle"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#32577E",
                      zIndex: 4,
                    }}
                  >
                    Sl No.
                  </TableCell>
                  <TableCell
                    className="tabalecellStyle"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#32577E",
                      zIndex: 4,
                    }}
                  >
                    Department Name
                  </TableCell>
                  {/* <TableCell
                    className="tabalecellStyle"
                    sx={{ px: { md: 10 } }}
                  ></TableCell> */}
                  <TableCell
                    className="tabalecellStyle"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#32577E",
                      zIndex: 4,
                    }}
                  >
                    Action
                  </TableCell>
                </TableHead>

                <TableBody>
                  {departmentList.map((form, index) => {
                    return (
                      <DepartmentUndertakingTableFormRow
                        key={`department-undertaking-form-${index}`}
                        rowData={form}
                        index={index}
                        undertakingFormList={allUndertakingFormList || []}
                        handleIsUndertakingRequiredStatusChange={
                          handleIsUndertakingRequiredStatusChange
                        }
                        handleDepartmentStatusChange={
                          handleDepartmentStatusChange
                        }
                        handleSaveUndertakingForm={handleSaveUndertakingForm}
                      />
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
        {/* {Boolean(savedUndertakingObj) && (
          <Box>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead
                  style={{ color: "#fff", backgroundColor: "#32577e" }}
                >
                  <TableCell className="tabalecellStyle">Sl No.</TableCell>
                  <TableCell className="tabalecellStyle">
                    Department Name
                  </TableCell>
                  <TableCell className="tabalecellStyle">
                    Is Undertaking Required
                  </TableCell>
                </TableHead>
                <TableBody>
                  {departmentList.map((department, index) => {
                    return (
                      <TableRow>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{department.departmentName}</TableCell>
                        <TableCell>
                          <Checkbox
                            size="small"
                            checked={department.isUndertakingFormRequired}
                            onChange={(e) => handleStatusChange(e, department)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )} */}
      </AccordionDetails>
    </Accordion>
  );
};

export default UnderTakingFormUpload;
